import React, { useContext, useState } from 'react'
import { Box, TextField, Button, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import Sidebar from './sidebar'
import CustomToolbar from './CustomToolbarPrint'
import DataContext from '../context/context'
import ProjectFilter from './ProjectFilter'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'
import { inDateRange, matchesProject } from '../utils/reportUtils'

export default function ReferralReport() {
  const dropDownData = useContext(DataContext)
  const [date1, setdate1] = useState('')
  const [date2, setdate2] = useState('')
  const [projectFilter, setprojectFilter] = useState([])
  const [rows, setRows] = useState([])
  const [rows1, setRows1] = useState([])

  const handleProjects = (projects) => {
    setprojectFilter(projects)
    setRows([])
    setRows1([])
  }

  const summaryColumns = [
    { field: 'referralForm', headerName: 'Housing Journey Referral From', width: 320 },
    { field: 'count', headerName: 'Count', width: 150 },
  ]

  const columns = [
    { field: 'firstName', headerName: 'Name', width: 140 },
    { field: 'surName', headerName: 'Surname', width: 140 },
    { field: 'referralForm', headerName: 'Housing Journey Referral From', width: 260 },
    { field: 'referralOthersDetails', headerName: 'Other Details', width: 220 },
    { field: 'startDate', headerName: 'Registered Date', width: 150 },
    { field: 'postCode', headerName: 'Postcode', width: 130 },
    { field: 'DOB', headerName: 'Date of Birth', width: 140 },
  ]

  const getData = async () => {
    if (projectFilter.length === 0) {
      setRows([])
      setRows1([])
      return
    }
    const q = collection(db, 'employee')
    const querySnapshot = await getDocs(q)

    const options = new Set(
      Array.isArray(dropDownData?.HousingJourneyReferralFrom)
        ? dropDownData.HousingJourneyReferralFrom
        : []
    )
    const details = []

    querySnapshot.forEach((document) => {
      const e = document.data()
      const referralForm = (e.referralForm || '').trim()
      if (referralForm) options.add(referralForm)
      if (!inDateRange(e.startDate, date1, date2)) return
      if (!matchesProject(e.gender, projectFilter)) return

      details.push({
        id: document.id,
        firstName: e.firstName || '',
        surName: e.surName || '',
        referralForm: referralForm || 'Not specified',
        referralOthersDetails: e.referralOthersDetails || '',
        startDate: e.startDate || '',
        postCode: e.postCode || '',
        DOB: e.DOB || '',
      })
    })

    if (details.some((d) => d.referralForm === 'Not specified')) {
      options.add('Not specified')
    }

    const summary = Array.from(options)
      .filter(Boolean)
      .sort()
      .map((form) => ({
        id: form,
        referralForm: form,
        count: details.filter((d) => d.referralForm === form).length,
      }))
      .filter((row) => row.count > 0)

    summary.push({ id: 'total', referralForm: 'Total', count: details.length })

    setRows(details)
    setRows1(summary)
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: '50px' }}>
        <div style={{ width: '100%' }}>
          <ProjectFilter value={projectFilter} onChange={handleProjects} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="Start Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate1(e.target.value)} value={date1} />
          <TextField type="date" InputLabelProps={{ shrink: true }} className="addform" label="End Date" variant="outlined" style={{ width: '45%' }} onChange={(e) => setdate2(e.target.value)} value={date2} />
          <Button onClick={getData} disabled={projectFilter.length === 0} className="addform" variant="contained" style={{ marginBottom: '10px', width: '100%', height: '50px', marginTop: '30px', backgroundColor: '#F21D2F' }}>Search</Button>

          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Overall Summary</Typography>
          <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
            Total referrals: {rows1.find((row) => row.id === 'total')?.count || 0}
          </Typography>
          <div style={{ height: '35vh', marginBottom: '20px' }}>
            <DataGrid rows={rows1} columns={summaryColumns} pageSize={25} rowsPerPageOptions={[25]} components={{ Toolbar: CustomToolbar }} />
          </div>

          <Typography variant="h6" sx={{ mb: 1 }}>Breakdown</Typography>
          <div style={{ height: 440 }}>
            <DataGrid rows={rows} columns={columns} pageSize={10} rowsPerPageOptions={[5]} components={{ Toolbar: CustomToolbar }} />
          </div>
        </div>
      </Box>
    </Box>
  )
}
